import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import SharedComponent from './Components/Utils/SharedComponent';
import AllPage from './Pages/Page/AllPage';
import AllPostPageComponent from './Components/PageComponents/AllPostPageComponent';
import AllCommentComponent from './Components/PageComponents/AllCommentComponent';
import 'react-loading-skeleton/dist/skeleton.css';
import LoginPage from './Pages/Login/LoginPage';
import ManageGroupsPage from './Pages/ManageGrousp/ManageGroupsPage';
import AllGroups from './Components/ManageGroupsComponents/AllGroups';
import { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getAuthData, getRole } from './RTK/Slice/Auth/AuthSlice';
import { Flip, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GroupPostsComponent from './Components/ManageGroupsComponents/GroupPostsComponent';
import ChangePassword from './Pages/changePassword/ChangePassword';
import GroupPostComments from './Components/ManageGroupsComponents/GroupPostComments';
import ExtractDataPage from './Pages/ExtractData/ExtractDataPage';
import ExtractPagePostId from './Components/ExtractData/ExtractPagePostId';
import ExtractPageSearch from './Components/ExtractData/ExtractPageSearch';
import GetPostsOfPageSearch from './Components/ExtractData/GetPostsOfPageSearch';
import ExtractPageSearchComments from './Components/ExtractData/ExtractPageSearchComments';
import ExtractPagePostCommentsWithID from './Components/ExtractData/ExtractPagePostCommentsWithID';
import ExtractSearch from './RTK/Slice/Extract/ExtractSearch';
import MessagesPage from './Pages/MessagesPage/MessagesPage';
import AllMessagesComponent from './Components/Messages/AllMessagesComponent';
import ExtractMorePostsPage from './Pages/ExtractMorePosts/ExtractMorePostsPage';
import AllUsersPage from './Pages/AllUsers/AllUsersPage';
import ExtractMoreComments from './Pages/ExtractMoreComments/ExtractMoreComments';
import ProfilePage from './Pages/Profile/ProfilePage';
import SpecificGroupPage from './Pages/SpecificGroup/SpecificGroupPage';
import GetGroupWithId from './Components/SpecificGroup/GetGroupWithId';
import SpecificGroupPostComments from './Components/SpecificGroup/SpecificGroupPostComments';
import SpecificPostPage from './Pages/SpecificPost/SpecificPostPage';
import SpecificPostWithId from './Components/SpecificPost/SpecificPostWithId';
import SpecificPostComments from './Components/SpecificPost/SpecificPostComments';
import ProtectedRoute from './Components/Auth/ProtectedRoute';
import GetTokenPage from './Pages/GetToken/GetTokenPage';
import NotFound from './Pages/NotFound/NotFoundPage';
import SpecificPerson from './Pages/SpecificPerson/SpecificPerson';
import ExtractGroupMemberPage from './Pages/ExtractGroupMember/ExtractGroupMemberPage';
import cookies from "js-cookie";
import i18n from './i18n';
import AllMessengersPage from './Pages/Messengers/AllMessengersPage';



function App() {

// For Get Auth Data if found
  const {Auth } = useSelector(getAuthData) ;

  const role = useSelector(getRole) ; 

  const lng = cookies.get('i18next') || 'en';





  // const lng = cookies.get("i18next") || 'en';
  const [auth ,setAuth] = useState(null) ; 
  // useEffect(()=>{
  //   // i18n.changeLanguage(active) ; 
  //   window.document.dir = i18n.dir();  
  // } , [ lng ]) 

  useEffect(()=>{
      
    setAuth(Auth);
  } , [Auth ])

  return (
    <Fragment>
    <ToastContainer limit={3} autoClose={2000} transition={Flip} stacked closeOnClick theme='colored' position='top-right' />

    <BrowserRouter>
      <Routes>
        <Route path='/' element={<ProtectedRoute> <SharedComponent/> </ProtectedRoute>} >
            <Route path='/' element={<AllPage />} />
            <Route path=':pageId/:pageToken' element={<AllPostPageComponent/>} />
            <Route path=":pageId/:pageToken/:postId" element={<AllCommentComponent />} />
            
            {/* For Message Pages */}
            <Route path="/messages/:pageId/:pageToken" element={<MessagesPage />}>
              <Route index element={<AllMessagesComponent />} />
             {/* <Route path=':messengers' element={<AllMessengersPage/>}  />*/}
            </Route>

            {/* For Get Token From Page */}
            {<Route path="gettoken" element={<GetTokenPage/>} />}

            <Route path="/manageGroups" element={<ManageGroupsPage />}>
              <Route index element={<AllGroups />} />
              <Route path=":groupId"  >
                <Route index element={<GroupPostsComponent />} />
                <Route path=":postId" element={<GroupPostComments />} />
              </Route>
            </Route>

            

            <Route path="/extractdata" element={<ExtractDataPage />}>
              <Route path="pageId" element={<ExtractPagePostId />} >
              </Route>
              
              <Route path='pageId/:postId' element={<ExtractPagePostCommentsWithID/>} />

              <Route path="search" element={<ExtractSearch />} >
                <Route index element={<ExtractPageSearch />} />
                <Route path=":pageID" element={<GetPostsOfPageSearch />} />                  
                <Route path=':pageID/:postId' element={<ExtractPageSearchComments />} />
                <Route path="extractMorePost" element={<ExtractMorePostsPage />} />
                <Route path='extractCommentsFromMorePost' element={<ExtractMoreComments />} />
              </Route>

              <Route path='specifcPerson' element={<SpecificPerson />} />

              <Route path='extractgroupmember' element={<ExtractGroupMemberPage />} />

              <Route path="specifcGroup" element={<SpecificGroupPage />}>
                <Route index element={<GetGroupWithId />} />
                <Route path=':postId' element={<SpecificGroupPostComments />} />
              </Route>

              <Route path="specifcPost" element={<SpecificPostPage />}>
                <Route index element={<SpecificPostWithId />} />
                <Route path=':postId' element={<SpecificPostComments />} />
              </Route>
              
            </Route>

            <Route path="/profile" element={<ProfilePage/>} />
            <Route path="/allusers" element={role !== "user" ?  <AllUsersPage /> : ""} />

            {/*<Route path="/change-password" element={<ChangePassword />} />*/}
        </Route>

        <Route path="/login" element={<LoginPage />} />

        <Route path="*" element={<NotFound />} />

      </Routes>
    </BrowserRouter>
    
    </Fragment>
  );
}

export default App;
